import React from 'react'
import { Outlet } from 'react-router-dom'

import AnimatedFlash from 'modules/core/components/AnimatedFlash'
import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import SectionContainer from 'modules/core/components/SectionContainer'
import { ClientSideFeatureFlagProvider } from 'modules/core/lib/clientSideFeatureFlags'
import { F0Provider } from 'modules/core/lib/f0-provider'
import hasFeature from 'modules/core/lib/hasFeature'
import legalEntities from 'modules/core/store/collections/legalEntities'

import Content from 'modules/bookkeepers/components/Content'
import type { DefaultParams } from 'modules/bookkeepers/hooks/useIncidenceFilters'
import CollectionsBootstrap from 'modules/bookkeepers/lib/CollectionsBootstrap'
import { IncidenceFilterProvider } from 'modules/bookkeepers/lib/IncidenceFilterContext'
import { BookkeeperViewProvider } from 'modules/bookkeepers/lib/bookkeeperViewContext'
import { allActive } from 'modules/bookkeepers/lib/filterOptions'
import { SORT_ATTRIBUTES } from 'modules/bookkeepers/lib/tableSortColumns'
import { LayoutProvider } from 'modules/layout/hooks/useFullscreen'

const Container = () => {
  const defaultFilterValues: DefaultParams = {
    filters: {
      status: allActive().value,
    },
    direction: 'asc',
    attribute: SORT_ATTRIBUTES.incidence_effective_date,
  }

  const hasProfessionalsAccess = hasFeature('factorial_professionals') && !legalEntities.isEmpty

  return (
    <AuthorizeUser authorizeFn={() => hasProfessionalsAccess}>
      {/*For now we will keep it always visible, but we need to think this*/}
      <IncidenceFilterProvider defaultFilterValues={defaultFilterValues}>
        <Content>
          <React.Suspense>
            <Outlet />
          </React.Suspense>
        </Content>
      </IncidenceFilterProvider>
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <ClientSideFeatureFlagProvider>
      <F0Provider>
        <CollectionsBootstrap>
          <BookkeeperViewProvider isBookkeeperView>
            <LayoutProvider>
              <AnimatedFlash />
              <SectionContainer>
                <Container />
              </SectionContainer>
            </LayoutProvider>
          </BookkeeperViewProvider>
        </CollectionsBootstrap>
      </F0Provider>
    </ClientSideFeatureFlagProvider>
  )
}

export default RootPage
